export default __webpack_public_path__ + "static/media/5.816173bb.jpg";